<template>
  <div>
    <notification-message
      message="Debes actualizar tu contraseña"
      v-if="user.updatePassword"
    />
    <div class="main-content-container container-fluid px-4">
    	<div>
    		<div class="page-header row no-gutters py-4">
    			<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
    			  <span class="text-uppercase page-subtitle">Escritorio</span>
    			  <h3 class="page-title">Visión general</h3>
    		  </div>
    	  </div>
        <div class="row">
          <quantity-indicator name="soluciones" endpoint="/solution/quantity"/>
          <quantity-indicator name="servicios" endpoint="/service/quantity"/>
          <quantity-indicator name="publicaciones" endpoint="/post/quantity"/>
          <quantity-indicator name="proyectos" endpoint="/project/quantity"/>
        </div>
        <div class="row">
          <messages/>
          <job-requests/>
        </div>
    	</div>
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/general/NotificationMessage';
  import Messages from '@/components/dashboard/home/Messages.vue';
  import QuantityIndicator from '@/components/dashboard/home/QuantityIndicator.vue';
  import JobRequests from '@/components/dashboard/home/JobRequests.vue';
  
  export default {
    components: { NotificationMessage, QuantityIndicator, Messages, JobRequests},
    
    computed: {
      user: function() {
        return this.$store.state.auth.user
      }
    }
  }
</script>
